import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import MergeClassNames from 'utils/MergeClassNames';

interface IButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  children: ReactNode;
}

export default function Button({
  children,
  className,
  variant,
  size,
  ...props
}: IButtonProps) {
  return (
    <button
      className={MergeClassNames(buttonVariants({ variant, size, className }))}
      {...props}
    >
      {children}
    </button>
  );
}

const buttonVariants = cva(
  'rounded-[var(--radius-button)] cursor-pointer disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        primary:
          'bg-primary hover:bg-primary-dark text-white disabled:cursor-not-allowed disabled:opacity-50',
        // Grey text (OP-2490) — the green read as a second brand accent on
        // quiet controls; green stays for the success variant.
        secondary:
          'bg-white hover:bg-gray-bright text-gray-dark border border-gray-argent disabled:cursor-not-allowed disabled:bg-secondary disabled:text-secondary-dark focus:ring-secondary-light ring-offset-tiny focus:ring-1',
        success:
          'bg-success-dark text-white border-none focus:ring-success ring-offset-tiny focus:ring-1',
        danger: 'bg-danger-dark hover:bg-danger text-white',
      },
      size: {
        sm: 'text-sm px-1 py-1',
        md: 'text-base px-2 py-2.5',
        lg: 'text-lg px-3 py-3',
        xl: 'text-xl px-6 py-2',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);
